<template>
  <div class="app-tariff-info" v-if="bookedTariff.tariffExtra">
    <slot name="txtBefore"></slot>
      <button :class="['tariff-btn', 'tariff-' + bookedTariff.tariffId, 'tariff-' + bookedTariff.tariffExtra.class ]" @click="showInfo">{{ bookedTariff.name }}</button>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

export default {
  name: 'TariffInfo',
  props: {
    bookedTariff: {
      type: Object,
      default: null
    }
  },
  methods: {
    showInfo () {
      this.$emit('show-info')
    }
  }
}
</script>
